import { render, staticRenderFns } from "./orderproreport.vue?vue&type=template&id=18580f0a&scoped=true&"
import script from "./orderproreport.vue?vue&type=script&lang=js&"
export * from "./orderproreport.vue?vue&type=script&lang=js&"
import style0 from "./orderproreport.vue?vue&type=style&index=0&id=18580f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18580f0a",
  null
  
)

export default component.exports